import script from "./ButtonFixedTertiary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonFixedTertiary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonFixedTertiary.vue?vue&type=style&index=0&id=14f9b7cd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f9b7cd"]])

export default __exports__